<template>
    <div class="menu-div" v-if="tabList.length>0" :class="[showLeftPx?'':'menu-div-Hide']">
        <div class="icon-item" style="left:0px" @click="handleScroll(240)">
            <Icon class="slideIcon" type="ios-arrow-dropleft-circle"  size="24"/>
        </div>
        <div class="tabw-div" ref="scrollOuter">
            <div class="scroll-div" ref="scrollBody">
                <div  class="items"  @click="selectM(item,index)" :ref="'scrollitem'+index"  :class="selectMenuItem.activeId == item.activeId ?'itemsActive':''"  v-for="(item,index) in tabList"  :key="index">
                     <div class="homecircle" v-if='item.routeName == "home"'>
                    </div>
                    <div>{{showTitle(item)}}</div>
                    <div class="icons" v-if='item.routeName !== "home"'>
                        <Icon type="ios-close" class="iconClose" @click.stop="reduceMenu(item,index)"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="icon-item" style="right:40px" @click="handleScroll(-240)">
             <Icon class="slideIcon" type="ios-arrow-dropright-circle" size="24" />
        </div>
        <div class="icon-item" style="right:0px">
            <Dropdown @on-click='closeMenu'> 
                <a href="javascript:void(0)">
                  <Icon type="ios-arrow-down" size="24" />
                </a>
                <DropdownMenu slot="list" >
                    <DropdownItem name='1' @click="closeMenu(1)">{{$t('topCon.colseLeft')}}</DropdownItem>
                    <DropdownItem name='2' @click="closeMenu(2)">{{$t('topCon.colseRight')}}</DropdownItem>
                    <DropdownItem name='3' @click="closeMenu(3)">{{$t('topCon.colseOther')}}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
    </div>
</template>
<script>
import common from "@/common/common.js";
import time from "@/common/time.js";
import { showTitle } from '../../libs/util'
import $ from "jquery"

let mWidth = 0
export default {
  name: "TopTabMenu",
  components: {},
  data() {
    return {
      selectMenuItem: { id: 0 },
      tabList: [],
      outerPadding: 0,
      tagBodyLeft:0
    };
  },
  computed: {
    getSelectMenuItem() {
      return this.$store.state.selectMenuItem;
    },
    getTabList() {
      return this.$store.state.tabList;
    },
    showLeftPx(){
        return this.$store.state.showLeftPx
    }
  },
  watch: {
    getSelectMenuItem: {
      deep:true,
      handler(newValue, oldValue) {
        this.selectMenuItem = newValue;
      }
    },
    getTabList: {
      handler(newValue, oldValue) {
        this.tabList = newValue;
       
        this.$store.commit("setTabMenuList", this.tabList);
      }
    },
    '$route' (to) {
      this.getTagElementByRoute(to)
    },
  },
  created() {
    this.tabList = this.$store.state.tabList;
    this.selectMenuItem = this.$store.state.selectMenuItem;
    this.$store.commit("setTabMenuList", this.tabList);

    // console.log('this.tabList',this.tabList)
  },
  mounted(){
     this.renovate()
  },
  destroyed() {},
  methods: {
    showTitle (item) {
      return showTitle(item, this)
    },
    renovate(){//刷新，移动到相应位置
      if(this.getSelectMenuItem.tagBodyLeft){
       this.tagBodyLeft = this.getSelectMenuItem.tagBodyLeft
        $(".scroll-div").css({'left':this.tagBodyLeft})
      }
    },
    scrollD(val){//左右移动（旧）
        let tabwDivWidth = $(".tabw-div").width()
        let scrollDivWidth = $(".scroll-div").width()
        
        let maxWidths = 0
        if(scrollDivWidth<tabwDivWidth){
            return
        }else{
            maxWidths = scrollDivWidth-tabwDivWidth
        }
       let moveWidth = Number((scrollDivWidth/3).toFixed(0))
        if(val == 1){
            if(mWidth<0 && Math.abs(mWidth) >= Number((tabwDivWidth/3).toFixed(0))) return
            mWidth = mWidth-moveWidth
        }else{
            if(mWidth < 0){
                mWidth = mWidth+moveWidth
            }
        }
        if(Number(mWidth)>=Number(maxWidths)){
            return
        }
        $(".scroll-div").css({'left':mWidth})
    },
    handleScroll (offset) {//左右移动（新）
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      if (offset > 0) {//左
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
      } else {
        if (outerWidth < bodyWidth) {//有滚动条
          if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {
            this.tagBodyLeft = this.tagBodyLeft
          } else {
            this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, outerWidth - bodyWidth)
          }
        } else {
          this.tagBodyLeft = 0
        }
      }
      $(".scroll-div").css({'left':this.tagBodyLeft})
    },
    moveToView (tag) {//点击顶部标签居中
      if(this.tabList.length>0){
          const outerWidth = this.$refs.scrollOuter.offsetWidth
          const bodyWidth = this.$refs.scrollBody.offsetWidth  

          // console.log('tag.offsetLeft',tag.offsetLeft)
          // console.log('tag.tagBodyLeft',this.tagBodyLeft)
          // console.log('bodyWidth',bodyWidth)


          // if (bodyWidth < outerWidth) {
          //   this.tagBodyLeft = 0
          // } else if (tag.offsetLeft <= -this.tagBodyLeft) {
          //   // 标签在可视区域左侧
          //   this.tagBodyLeft = -tag.offsetLeft + this.outerPadding
          //   console.log('左')
          // } else if (tag.offsetLeft > -this.tagBodyLeft && tag.offsetLeft + tag.offsetWidth < -this.tagBodyLeft + outerWidth) {
            
          //   // 标签在可视区域
          //   this.tagBodyLeft = Math.min(0, outerWidth - tag.offsetWidth - tag.offsetLeft - this.outerPadding)
          //   console.log('中')
          // } else {
          //   // 标签在可视区域右侧
          //   console.log('右')
          //   this.tagBodyLeft = -(tag.offsetLeft - (outerWidth - this.outerPadding - tag.offsetWidth))-100
          // }

          if (bodyWidth < outerWidth) {
            this.tagBodyLeft = 0
          } else{
               //中间值 =( 屏幕宽度 - li宽度 ) / 2;
              let diffWidth = (outerWidth - tag.offsetWidth) / 2,
              //目标值 = offset - 中间值
              targetOffset = -(tag.offsetLeft - diffWidth);
              this.tagBodyLeft = Math.min(0, targetOffset)
              //  console.log('targetOffset',targetOffset)
          }
         
           this.$store.commit("setTabMenuItem", {...this.$store.state.selectMenuItem,tagBodyLeft:this.tagBodyLeft});
          
           $(".scroll-div").css({'left':this.tagBodyLeft})
      }
     
    },
    getTagElementByRoute (route) { //点击左侧，标签居中
      // console.log('route',route)
      this.$nextTick(() => {
        if(route.path =='/home'){
            let tag = (this.$refs['scrollitem0'])[0]
            this.$store.commit("setTabMenuItem",  this.tabList[0]);
            this.moveToView(tag)
            return
        }
        this.tabList.forEach((item, index) => {
          if('/'+item.routerUrl==route.path || item.routerUrl==route.path){
            let tag = (this.$refs['scrollitem'+index])[0]
            if(route.path != '/'+this.getSelectMenuItem.routerUrl){
               this.$store.commit("setTabMenuItem", item);
             }
            this.moveToView(tag)
          }
        })
        
      })
    },
    selectM(item, index) {
      this.$store.commit("setTabMenuItem", item);
      // this.moveToView((this.$refs['scrollitem'+index])[0])

      if(item.routerUrl == 'home'){
           this.$router.push({ name: 'home' })
      }else{
          this.$router.push({ path: item.routerUrl, })
      }
    },

    reduceMenu(item, index) {
      this.tabList.splice(index, 1);
      if (this.tabList.length <= 1) {
        setTimeout(() => {
            this.selectMenuItem.activeId = 'fhome'
            this.$router.push({ name: 'home' })
           
        }, 300);
        return
      }
      this.$store.commit("setTabMenuList", this.tabList);

      if (this.selectMenuItem.activeId != item.activeId) return;
      setTimeout(() => {
        if (index > 0) {
          this.$store.commit("setSlideItem", this.tabList[index - 1]);
          this.$router.push({ path: this.tabList[index-1].routerUrl, })
        } else {
         
          this.$store.commit("setSlideItem", this.tabList[index + 1]);
        }
        
      }, 500);
      
    },
    closeMenu(val){
        let tabList = []
        let itemD = ''
         if(this.tabList.length <= 0) return
        let offIndex1 = this.tabList.findIndex((mitem,index) => {
            return this.selectMenuItem.activeId == mitem.activeId
        })
        if(val == 1){ 
            if(offIndex1<=0) return
            itemD = this.tabList[offIndex1]
            this.tabList.splice(0,offIndex1)
            if(this.selectMenuItem.activeId !='0-1'){
              this.tabList.unshift({activeId: "0-1",fId: 0,fTitle: "平台首页",name: "平台首页",routeName: "home",routerUrl: "/"})
            }
            $(".scroll-div").css({'left':0})
        }else if(val == 2){
            if(offIndex1 == this.tabList.length-1) return
             itemD = this.tabList[offIndex1]
            this.tabList.splice(offIndex1+1,this.tabList.length)
        }else if(val == 3){
            if(this.tabList.length == 1) return
             itemD = this.tabList[offIndex1]
            this.tabList = [this.tabList[offIndex1]]
             if(this.selectMenuItem.activeId !='0-1'){
              this.tabList.unshift({activeId: "0-1",fId: 0,fTitle: "平台首页",name: "平台首页",routeName: "home",routerUrl: "/"})
            }
            $(".scroll-div").css({'left':0})
        }
       
        this.$store.commit("setTabMenuList", this.tabList);
        this.$store.commit("setTabMenuItem", itemD);
    }
  }
};
</script>
<style>
.slideIcon:hover{
  color: #4ABAF0;
}
.tabw-div {
  /* display: flex; */
     cursor: pointer;
    overflow: hidden;
    overflow: hidden;
    height: 50px;
    width: 100%;
    position: relative;
}
.homecircle{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #4ABAF0;
    margin-right: 10px;
}
.tabw-div .scroll-div{
    /* width: 120%; */
    white-space:nowrap;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    transition: all 0.3s;
    display: flex;
}
.tabw-div .items {
  font-size: 14px; 
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  box-sizing: border-box;
  border-left: 1px solid #EDEDED;
  background: #ffffff;
  transition: 0.5s all;
  border-top: 2px solid #fff;
  border-bottom: 1px solid #EDEDED;
  float: left;
}
.tabw-div .items .icons {
  border-radius: 100%;
  display: inline-flex;
  /* border: 1px solid; */
  margin-left: 5px;
  transition: 0.5s all;
}
.tabw-div .items .icons:hover {
  background-color: #4ABAF0;
  color: #fff;
  transition: 0.5s all;
}
.tabw-div .items .iconClose {
  font-size: 20px;
}
.tabw-div .items:hover {
  background-color: #f6f6f6;
  border-top: 2px solid #4ABAF0;
}
.tabw-div .itemsActive {
  transform: 0.5s all;
  background-color: #EDEDED;
  border-top: 2px solid #4ABAF0;
}
.menu-div {
 z-index: 1;
  position: absolute;
  top:63px;
  left: 260px;
  width:calc(100% - 260px);  
  height: 40px;
  background-color: #fff;
  box-sizing: border-box;
  /* box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1); */
  padding: 0px 80px 0px 40px;
  border-bottom: 1px solid #EDEDED;
  border-top: 1px solid #EDEDED;
  transition: all .3s ease-in-out;
}

.menu-div-Hide{
  left: 0px;
  width:100%;  
}
.menu-div .icon-item {
  position: absolute;
  top: 0;
  width: 40px;

  height: 100%;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  box-sizing: border-box;
  border-left: 1px solid #f6f6f6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-div .icon-item img {
  width: 20px;
  height: 20px;
}
</style>
